import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Keep in sync with `functions/src/api/public_lead_submissions.py`. */
export const PUBLIC_LEAD_MAX_NAME = 200;
export const PUBLIC_LEAD_MAX_EMAIL = 320;
export const PUBLIC_LEAD_MAX_ORG = 200;
export const PUBLIC_LEAD_MAX_MESSAGE = 8000;

/** Matches server-side public lead email check (see functions public_lead_submissions). */
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function isValidPublicLeadEmail(email: string): boolean {
  return EMAIL_RE.test((email || '').trim());
}

/** Treats whitespace-only as empty (unlike `Validators.required`). */
export function trimmedRequired(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || String(raw).trim() === '') {
    return { required: true };
  }
  return null;
}

/** Non-empty values must match the public lead API email pattern. */
export function publicLeadEmailValidator(control: AbstractControl): ValidationErrors | null {
  const raw = control.value;
  if (raw == null || String(raw).trim() === '') {
    return null;
  }
  return isValidPublicLeadEmail(String(raw)) ? null : { email: true };
}
